import problema01 from "./cartas/problema-01.webp";
import problema02 from "./cartas/problema-02.webp";
import problema03 from "./cartas/problema-03.webp";
import problema04 from "./cartas/problema-04.webp";
import problema05 from "./cartas/problema-05.webp";
import problema06 from "./cartas/problema-06.webp";
import problema07 from "./cartas/problema-07.webp";
import problema08 from "./cartas/problema-08.webp";
import problema09 from "./cartas/problema-09.webp";
import problema10 from "./cartas/problema-10.webp";
import raroAjuda from "./cartas/raro-ajuda.webp";
import raroAmeaca from "./cartas/raro-ameaca.webp";
import solucao01 from "./cartas/solucao-01.webp";
import solucao02 from "./cartas/solucao-02.webp";
import solucao03 from "./cartas/solucao-03.webp";
import solucao04 from "./cartas/solucao-04.webp";
import solucao05 from "./cartas/solucao-05.webp";
import solucao06 from "./cartas/solucao-06.webp";
import solucao07 from "./cartas/solucao-07.webp";
import solucao08 from "./cartas/solucao-08.webp";
import solucao09 from "./cartas/solucao-09.webp";
import solucao10 from "./cartas/solucao-10.webp";

// As 22 cartas de Sul / Pampa — o dado, separado do
// descritor. Transcritas de Cards_Curiosidade_Sul02.md por
// ferramentas-da-trilha/gerar-cartas-trilha.py, e não à mão: o erro
// provável numa transcrição de 22 textos é a pílula de um card cair em
// outro, e nenhum teste pega isso.
//
// O NOME DO ARQUIVO É O ID, sem o prefixo da região (a pasta já é a
// região). `card_id` é a CHAVE da coleção do aluno em
// `activity_ludic_trail_collection` e não se renomeia depois de gravada.
//
// Sem campo `fase`: a posição na trilha vem do sorteio.

// Banco fixo de 20: o sorteio tira 4 por trilha sem repetir (ver
// ava/progressoDoAluno.js), e o tamanho do banco é o que dá chance de
// carta nova quando o aluno refaz.
export const CARDS_COMUNS_SUL = [
  {
    id: "sul-problema-01",
    tipo: "problema",
    nome: "Campo Arado",
    asset: problema01,
    pilula:
      "Quando o trator ara o campo nativo pra plantar soja e arroz, o capim onde o gato-palheiro caça e cria os filhotes desaparece de uma vez."
  },
  {
    id: "sul-problema-02",
    tipo: "problema",
    nome: "Fileira de Eucalipto",
    asset: problema02,
    pilula:
      "O gato-palheiro é bicho de campo aberto: onde plantam eucalipto em fileiras fechadas, ele simplesmente não consegue viver."
  },
  {
    id: "sul-problema-03",
    tipo: "problema",
    nome: "Filhote Levado pra Casa",
    asset: problema03,
    pilula:
      "Quem acha um filhote de gato-palheiro no campo e leva pra casa achando que é gatinho de rua condena ele a nunca aprender a caçar."
  },
  {
    id: "sul-problema-04",
    tipo: "problema",
    nome: "A Isca Envenenada",
    asset: problema04,
    pilula:
      "O gato-palheiro caça o rato que comeu a isca de veneno e se envenena junto, sem nunca ter chegado perto dela."
  },
  {
    id: "sul-problema-05",
    tipo: "problema",
    nome: "Campo Raspado pelo Gado",
    asset: problema05,
    pilula:
      "Gado demais na mesma área come o capim até o chão, e sem capim alto o gato-palheiro fica sem esconderijo pra caçar e se abrigar."
  },
  {
    id: "sul-problema-06",
    tipo: "problema",
    nome: 'Fogo pra "Limpar" o Pasto',
    asset: problema06,
    pilula:
      "A queimada que renova o pasto destrói num dia a palha seca e os tufos de capim onde o gato-palheiro passa o dia escondido."
  },
  {
    id: "sul-problema-07",
    tipo: "problema",
    nome: "Estrada ao Anoitecer",
    asset: problema07,
    pilula:
      "Pequeno, cinzento e caçando à noite, o gato-palheiro é quase invisível pro motorista nas estradas que cortam o Pampa."
  },
  {
    id: "sul-problema-08",
    tipo: "problema",
    nome: "Morto por Engano",
    asset: problema08,
    pilula:
      "Parecido com um gato de rua, o gato-palheiro é tratado como invasor e morto quando aparece perto das casas da fazenda."
  },
  {
    id: "sul-problema-09",
    tipo: "problema",
    nome: "Gato de Casa Solto no Campo",
    asset: problema09,
    pilula:
      "Gatos domésticos soltos nas fazendas passam doenças ao gato-palheiro, que não tem quem o vacine no meio do campo."
  },
  {
    id: "sul-problema-10",
    tipo: "problema",
    nome: "Areia no Lugar do Campo",
    asset: problema10,
    pilula:
      "No sudoeste do Pampa, o campo arado em solo arenoso vira mancha de areia solta — e onde não nasce capim, o gato-palheiro não tem o que caçar."
  },
  {
    id: "sul-solucao-01",
    tipo: "solucao",
    nome: "Pecuária de Campo Nativo",
    asset: solucao01,
    pilula:
      "Criar gado sobre o campo nativo, sem arar nem plantar árvore, mantém o Pampa aberto e o gato-palheiro morando dentro da fazenda."
  },
  {
    id: "sul-solucao-02",
    tipo: "solucao",
    nome: "Ilhas de Capim Alto",
    asset: solucao02,
    pilula:
      "Deixar manchas de capim alto sem gado cria os esconderijos e o berçário de que os filhotes do gato-palheiro precisam."
  },
  {
    id: "sul-solucao-03",
    tipo: "solucao",
    nome: "O Filhote Não Está Perdido",
    asset: solucao03,
    pilula:
      "Filhote de gato-palheiro sozinho no capim não foi abandonado: a mãe está caçando e volta — o certo é sair de perto e avisar um adulto."
  },
  {
    id: "sul-solucao-04",
    tipo: "solucao",
    nome: "O Melhor Ratoeiro do Campo",
    asset: solucao04,
    pilula:
      "Um único gato-palheiro come centenas de roedores por ano: mantê-lo vivo protege a lavoura de graça, sem nenhum veneno."
  },
  {
    id: "sul-solucao-05",
    tipo: "solucao",
    nome: "Trazer o Capim Nativo de Volta",
    asset: solucao05,
    pilula:
      "Recuperar o campo que virou areia ou foi tomado por capim de fora devolve ao gato-palheiro as aves e os roedores que ele caça."
  },
  {
    id: "sul-solucao-06",
    tipo: "solucao",
    nome: "Aceiro no Lugar da Queimada",
    asset: solucao06,
    pilula:
      "Combinar de não pôr fogo no campo e abrir aceiros preserva a palha e os tufos que servem de abrigo pro gato-palheiro."
  },
  {
    id: "sul-solucao-07",
    tipo: "solucao",
    nome: "Pé no Freio ao Anoitecer",
    asset: solucao07,
    pilula:
      "Reduzir a velocidade nos trechos de campo quando o sol cai é o que evita atropelar o gato-palheiro na hora em que ele sai pra caçar."
  },
  {
    id: "sul-solucao-08",
    tipo: "solucao",
    nome: "Gato de Casa Vacinado",
    asset: solucao08,
    pilula:
      "Vacinar e castrar os gatos da fazenda impede que doenças cheguem ao gato-palheiro do campo."
  },
  {
    id: "sul-solucao-09",
    tipo: "solucao",
    nome: "Reservas no Campo Nativo",
    asset: solucao09,
    pilula:
      "O Pampa é o bioma brasileiro com menos áreas protegidas: criar parques no campo nativo garante um pedaço seguro pro gato-palheiro."
  },
  {
    id: "sul-solucao-10",
    tipo: "solucao",
    nome: "Câmera Escondida no Capim",
    asset: solucao10,
    pilula:
      "O gato-palheiro quase nunca é visto de perto: são as câmeras escondidas no campo que provam que ele ainda vive ali — e mostram onde proteger primeiro."
  }
];

// Fora do sorteio: o arco do mascote, em 1ª pessoa. A ORDEM importa, e o
// casamento é ALINHADO PELO FIM (ver nucleo/recompensaDaFase.js) — numa
// trilha de 2 a 4 passos existe uma fase rara só, e ela tem de receber o
// FECHO. O último item é o único que todo aluno vê, e o único com
// `comemorar: true`.
export const CARDS_RAROS_SUL = [
  {
    id: "sul-raro-ameaca",
    tipo: "raro",
    nome: "Meu Campo Está Sumindo",
    asset: raroAmeaca,
    pilula:
      "O campo onde eu caço está sendo arado, o capim alto que me esconde já quase não existe e o rato que eu como vem cheio de veneno. Continue a exploração pra me ajudar a salvar o Pampa!"
  },
  {
    id: "sul-raro-ajuda",
    tipo: "raro",
    nome: "O Pampa Está de Pé!",
    asset: raroAjuda,
    comemorar: true,
    pilula:
      "Graças a você já tem gente do meu lado: campo nativo sem arado, ilhas de capim alto guardadas e rato pego sem veneno. Continue de olho na natureza — o campo que me abriga é o mesmo que dá o arroz e a carne do seu prato!"
  }
];

export const CARDS_SUL = [...CARDS_COMUNS_SUL, ...CARDS_RAROS_SUL];
